<template>
  <div>
    <v-card>
      <v-tabs
        show-arrows
        icons-and-text
        mb-5
        dark
        background-color="indigo darken-1"
        class="sticky"
      >
        <v-tab
          key="udaje_o_klientovi"
          :to="udaje_o_klientovi"
        >
          Údaje o klientovi
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab
          key="swot"
          :to="swot"
        >
          SWOT
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab
          key="rizika_a_dohlad"
          :to="rizika_a_dohlad"
        >
          Riziká a dohľad
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab
          key="potreby_plan"
          :to="potreby_plan"
        >
          Potreby Plán
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab v-if="item.permissions.add"
          key="socialne_programy"
          :to="socialne_programy"
        >
          Programy
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab
          key="aktualny_stav"
          :to="aktualny_stav"
        >
          Aktuálny stav
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab
          key="dokumenty"
          :to="dokumenty"
        >
          Dokumenty
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab v-if="item.permissions.add"
          key="prehlad_zmien"
          :to="prehlad_zmien"
        >
          Prehľad zmien
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab
          v-if="item.spracovatelia || item.spracovatelia_upsvar"
          key="spracovatelia"
          :to="spracovatelia"
        >
          Spracovatelia
          <v-icon>mdi-group</v-icon>
        </v-tab>
      </v-tabs>
    </v-card>
    <div class="px-5 py-5">
      <v-card
        shaped
        class="mt-15"
      >
        <v-card-title>
          {{ item.prisoner_full.string_details }}
        </v-card-title>
        <v-card-text>
          <router-view />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();
export default {

  data() {
    return {
      timer: "",
      headline: "",

      permissions: {},
      item: {
        prisoner_full: { string_details: "" }
      },
    };
  },

  computed: {
    udaje_o_klientovi() {
      return "/iapsz/" + this.$route.params.id + "/udaje_o_klientovi";
    },
    rizika_a_dohlad() {
      return "/iapsz/" + this.$route.params.id + "/rizika_a_dohlad";
    },
    swot() {
      return "/iapsz/" + this.$route.params.id + "/swot";
    },
    potreby_plan() {
      return "/iapsz/" + this.$route.params.id + "/potreby_plan";
    },
    socialne_programy() {
      return "/iapsz/" + this.$route.params.id + "/socialne_programy";
    },
    aktualny_stav() {
      return "/iapsz/" + this.$route.params.id + "/aktualny_stav";
    },
    dokumenty() {
      return "/iapsz/" + this.$route.params.id + "/dokumenty";
    },
    prehlad_zmien() {
      return "/iapsz/" + this.$route.params.id + "/prehlad_zmien";
    },
    spracovatelia() {
      return "/iapsz/" + this.$route.params.id + "/spracovatelia";
    },
  },
  mounted() {
    apiService.getIapszForm(this.$route.params.id).then((response) => {
      this.item = response;
    });
  },

  beforeDestroy() { },

  methods: {},
};
</script>
<style scoped>
.sticky {
  position: fixed;
  z-index: 1;
}
</style>